/**
 * DRKN tiny slider
 */
if (!customElements.get('gallery-slideshow')) {

    class GallerySlideshow extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            document.addEventListener("DOMContentLoaded", this.initSlideshow.bind(this));
        }

        initSlideshow() {
            let sliderOptions = {
                container: this,
                slideBy: this.dataset.slideBy ? this.dataset.slideBy : 'page',
                autoHeight: false,
                items: 1,
                autoplay: this.dataset.autoplay === "true",
                autoplayButtonOutput: false,
                controls: this.dataset.controls === "true",
                controlsContainer: this.parentElement.querySelector('.gallery--slideshow-controls-container'),
                nav: this.dataset.nav === "true",
                navPosition: 'bottom',
                gutter: this.dataset.gutter ? this.dataset.gutter : 0,
                responsive: {
                    768: {
                        items: 2
                    },
                    1640: {
                        items: this.dataset.items ? this.dataset.items : 1
                    }
                }
            }

            tns(sliderOptions);

        }
    }

    customElements.define('gallery-slideshow', GallerySlideshow);
}